import React from "react";
import { FormattedMessage } from "react-intl";

import { ProtectionStatus } from "../../../spson/roamingTables/ProtectionStatus";
import { showValue, timeSort } from "../../../../components/table/helpers";
import { ClickAbsorber } from "../../../../components/clickAbsorber/ClickAbsorber";
import { RoamingDevicesDropdownActions } from "./components";
import {
  RoamingDeviceNameCard,
  RoamingDeviceNameMobileCard,
} from "../../../spson/roamingTables/RoamingDeviceNameCard";
import { ellipsifyUUID } from "../../../../helpers/devices.helpers";
import { FormattedProfileName } from "../../../../components/formattedProfileName/FormattedProfileName";

const COMMON_COLUMNS = [
  {
    Header: <FormattedMessage id={"protection_status"} />,
    accessor: "protectionStatus",
    cellClassName: "table__cell--left",
    headerClassName: "table__cell--left",
    Cell: ({ row }) => (
      <ProtectionStatus status={row.original.protectionStatus} />
    ),
  },
  {
    Header: <FormattedMessage id={"last_seen_devices_table_header"} />,
    accessor: "lastSeen",
    sortType: timeSort,
    cellClassName: "color-table__cell",
    Cell: ({
      row: {
        original: { lastSeen },
      },
    }) => <div>{showValue(lastSeen)}</div>,
  },
  {
    Header: <FormattedMessage id={"actions"} />,
    id: "actions",
    sortable: false,
    headerClassName: "table__cell--small-cell",
    cellClassName: "table__cell--center table__cell--overflow",
    Cell: ({
      row: {
        original: { identifier, fullName, name },
      },
    }) => (
      <ClickAbsorber>
        <RoamingDevicesDropdownActions
          identifier={identifier}
          fullName={fullName}
          name={name}
        />
      </ClickAbsorber>
    ),
  },
];

export const COLUMNS_MOBILE = [
  {
    accessor: "name",
    SortingLabel: <FormattedMessage id={"device_name_devices_table_header"} />,
    Cell: ({
      row: {
        isExpanded,
        original: { identifier, name, protectionStatus, lastSeen },
      },
    }) => (
      <RoamingDeviceNameMobileCard
        isExpanded={isExpanded}
        name={name}
        lastSeen={lastSeen}
        protectionStatus={protectionStatus}
        aside={
          <RoamingDevicesDropdownActions
            identifier={identifier}
            fullName={name || ellipsifyUUID(identifier)}
            name={name}
          />
        }
      />
    ),
  },
  {
    SortingLabel: <FormattedMessage id={"protection_status"} />,
    accessor: "protectionStatus",
  },
  {
    accessor: "lastSeen",
    sortType: timeSort,
    SortingLabel: <FormattedMessage id={"last_seen_devices_table_header"} />,
  },
];

export const COLUMNS_TABLET = [
  {
    Header: <FormattedMessage id={"device_name_devices_table_header"} />,
    accessor: "name",
    headerClassName: "roaming-name-column",
    SortingLabel: <FormattedMessage id={"device_name_devices_table_header"} />,
    Cell: ({
      row: {
        isExpanded,
        original: { name, profile },
      },
    }) => (
      <div>
        <RoamingDeviceNameCard isExpanded={isExpanded} name={name} />
        <div className="device-group-substring">
          <FormattedProfileName profileName={profile} />
        </div>
      </div>
    ),
  },
  ...COMMON_COLUMNS,
];

export const COLUMNS_DESKTOP = [
  {
    Header: <FormattedMessage id={"device_name_devices_table_header"} />,
    accessor: "name",
    SortingLabel: <FormattedMessage id={"device_name_devices_table_header"} />,
    Cell: ({
      row: {
        isExpanded,
        original: { name },
      },
    }) => <RoamingDeviceNameCard isExpanded={isExpanded} name={name} />,
  },
  {
    Header: <FormattedMessage id={"group"} />,
    accessor: "profile",
    Cell: ({ row: { original } }) => (
      <FormattedProfileName profileName={original.profile} />
    ),
  },
  ...COMMON_COLUMNS,
];

export const SEARCH_KEYS = [
  "appStatus",
  "fullName",
  "identifier",
  "lastSeen",
  "model",
  "name",
  "os",
  "softwareVersion",
];

export const INITIAL_SORT = [{ id: "lastSeen", desc: true }];
